import {
  Component,
  OnInit
} from '@angular/core';

@Component ( {
  selector: 'reporter-fed-auth',
  imports: [],
  templateUrl: './fed-auth.component.html',
  styleUrl: './fed-auth.component.scss',
} )
export class FedAuthComponent implements OnInit {
  constructor () {
  }

  ngOnInit () {
  }

}
